import { ArrowUpRight, Sparkles } from "lucide-react";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/1236a11f-ca38-4921-83f3-221e6d2210b6/images/96b4af38bd53276e22fd18b7dda9ef4671e31cd2b17e668449db8d34f24d94fb.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden grain"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{ backgroundImage: `url(${HERO_IMG})` }}
      />
      <div className="absolute inset-0 hero-overlay" />

      {/* Ambient corner mark */}
      <div className="absolute top-24 sm:top-28 right-6 md:right-12 z-10 text-right hidden md:block">
        <p className="font-mono-small text-[#E5D0A1]/80">EST. 2014</p>
        <p className="font-mono-small text-white/40 mt-1">SCOTTSDALE · AZ</p>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 min-h-screen flex flex-col justify-end pt-32 sm:pt-28 pb-16 sm:pb-24 lg:pb-32">
        <div className="stagger max-w-5xl">
          <div className="flex items-center gap-3 flex-wrap">
            <span className="w-10 sm:w-12 h-px bg-[#E5D0A1] flex-shrink-0" />
            <p className="font-mono-small text-[#E5D0A1]">
              Soft Wash · Surface Care
            </p>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display text-white text-[44px] sm:text-7xl lg:text-[104px] leading-[0.92] tracking-[-0.04em] mt-8"
          >
            Pristine surfaces.
            <br />
            <span className="font-editorial italic text-[#E5D0A1] font-normal">
              Zero compromise.
            </span>
          </h1>

          <p
            data-testid="hero-subheadline"
            className="font-body text-white/70 text-lg sm:text-xl max-w-2xl mt-8 leading-relaxed font-light"
          >
            Scottsdale&apos;s quiet specialists in soft-wash exterior restoration.
            We don&apos;t just clean — we return stone, stucco and concrete to
            the day it was poured.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mt-12">
            <a
              href="#quote"
              data-testid="hero-primary-cta"
              className="group inline-flex items-center justify-center gap-3 bg-white text-black px-7 py-4 font-medium hover:bg-[#E5D0A1] transition-all duration-500"
            >
              <span>Get a 30-Second Quote</span>
              <ArrowUpRight
                className="w-4 h-4 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                strokeWidth={1.5}
              />
            </a>
            <a
              href="#showcase"
              data-testid="hero-secondary-cta"
              className="inline-flex items-center justify-center gap-3 bg-white/5 border border-white/20 text-white px-7 py-4 font-medium backdrop-blur-xl hover:bg-white/10 hover:border-white/40 transition-all duration-500"
            >
              <Sparkles className="w-4 h-4 text-[#E5D0A1]" strokeWidth={1.5} />
              <span>See Recent Work</span>
            </a>
          </div>
        </div>

        {/* Bottom strip */}
        <div className="mt-20 pt-8 border-t border-white/10 grid grid-cols-2 md:grid-cols-4 gap-y-6 gap-x-4">
          {[
            ["A+", "BBB · Insured & Bonded"],
            ["1,200+", "Properties Restored"],
            ["48 hr", "Average Response"],
            ["★ 4.97", "Across 380 Reviews"],
          ].map(([num, label]) => (
            <div key={label} className="flex flex-col">
              <span className="font-display text-white text-2xl sm:text-3xl tracking-tight">
                {num}
              </span>
              <span className="font-mono-small text-white/40 mt-2">{label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Vertical text */}
      <div className="hidden lg:flex absolute left-6 top-1/2 -translate-y-1/2 z-10 [writing-mode:vertical-rl] rotate-180 font-mono-small text-white/40 gap-4">
        Scroll · Sonoran Co.
      </div>
    </section>
  );
}
